
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <!-- Filter bar -->
    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="designationFilter" class="filter-label">Designation</label>
          <p-multiSelect id="designationFilter" [(ngModel)]="selectedDesignationFilter" (ngModelChange)="applyFilters()"
            [options]="designationOptions" optionLabel="label" optionValue="value" placeholder="All Designations"
            [showClear]="true" [filter]="true" filterPlaceholder="Search..." [maxSelectedLabels]="2" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="departmentFilter" class="filter-label">Department</label>
          <p-multiSelect id="departmentFilter" [(ngModel)]="selectedDepartmentFilter" (ngModelChange)="applyFilters()"
            [options]="departmentOptions" optionLabel="label" optionValue="value" placeholder="All Departments"
            [showClear]="true" [filter]="true" filterPlaceholder="Search..." [maxSelectedLabels]="2" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Table -->
    <p-table [scrollable]="true" scrollHeight="flex" [value]="filteredRecords" [loading]="loading"
      [paginator]="showPaginator" [alwaysShowPaginator]="false" [rows]="rows" [totalRecords]="totalRecords"
      [first]="first" [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} employees"
      styleClass="p-datatable onboarding-employee-table no-column-lines">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="employeeName">Name <p-sortIcon field="employeeName" /></th>
          <th pSortableColumn="designationName">Designation <p-sortIcon field="designationName" /></th>
          <th pSortableColumn="departmentName">Department <p-sortIcon field="departmentName" /></th>
          <th pSortableColumn="joiningDate">Joining Date <p-sortIcon field="joiningDate" /></th>
          <th *ngIf="!isLnDOnly" class="th-dept-col">IT</th>
          <th *ngIf="!isItOnly && !isLnDOnly" class="th-dept-col">P&amp;C</th>
          <th *ngIf="!isItOnly" class="th-dept-col">L&amp;D</th>
          <th *ngIf="!isItOnly && !isLnDOnly" class="th-dept-col">Orientation</th>
          <th *ngIf="!isItOnly && !isLnDOnly" class="th-dept-col">Welcome Email</th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-record>
        <tr>
          <td class="td-truncate" [pTooltip]="record.employeeName" tooltipPosition="top">{{ record.employeeName || '-' }}</td>
          <td class="td-truncate" [pTooltip]="record.designationName" tooltipPosition="top">{{ record.designationName || '-' }}</td>
          <td class="td-truncate" [pTooltip]="record.departmentName" tooltipPosition="top">{{ record.departmentName || '-' }}</td>
          <td>{{ formatDate(record.joiningDate) }}</td>

          <!-- IT — hidden for L&D-only users -->
          <td class="td-status-badge" *ngIf="!isLnDOnly">
            <p-tag [value]="getTaskLabel(record.itStatus)" [severity]="getTaskSeverity(record.itStatus)"
              [style]="{ cursor: (isAdminOrPc || authService.hasITAccess()) ? 'pointer' : 'default' }"
              (click)="(isAdminOrPc || authService.hasITAccess()) && openTaskDialog(record, 'IT')"
              pTooltip="IT — System & Access Setup" tooltipPosition="top" />
          </td>

          <!-- P&C — hidden for IT-only and L&D-only users -->
          <td class="td-status-badge" *ngIf="!isItOnly && !isLnDOnly && isAdminOrPc">
            <p-tag [value]="getTaskLabel(record.pnCStatus)" [severity]="getTaskSeverity(record.pnCStatus)"
              [style]="{ cursor: 'pointer' }" (click)="openTaskDialog(record, 'PnC')"
              pTooltip="P&C — Welcoming, Documents, Systems" tooltipPosition="top" />
          </td>
          <td class="td-status-badge" *ngIf="!isItOnly && !isLnDOnly && !isAdminOrPc">
            <p-tag [value]="getTaskLabel(record.pnCStatus)" [severity]="getTaskSeverity(record.pnCStatus)"
              [style]="{ cursor: 'default' }" pTooltip="P&C tasks" tooltipPosition="top" />
          </td>

          <!-- L&D — hidden for IT-only users; clickable for admin/pc/L&D -->
          <td class="td-status-badge" *ngIf="!isItOnly">
            <p-tag [value]="getTaskLabel(record.lnDStatus)" [severity]="getTaskSeverity(record.lnDStatus)"
              [style]="{ cursor: (isAdminOrPc || authService.hasLnDAccess()) ? 'pointer' : 'default' }"
              (click)="(isAdminOrPc || authService.hasLnDAccess()) && openTaskDialog(record, 'LnD')"
              pTooltip="L&D — Communication & Emails" tooltipPosition="top" />
          </td>

          <!-- Orientation — hidden for IT-only and L&D-only users -->
          <td class="td-status-badge" *ngIf="!isItOnly && !isLnDOnly && isAdminOrPc">
            <p-tag [value]="getTaskLabel(record.orientationStatus)" [severity]="getTaskSeverity(record.orientationStatus)"
              [style]="{ cursor: 'pointer' }" (click)="openTaskDialog(record, 'Orientation')"
              pTooltip="Orientation — IT, Company, P&C" tooltipPosition="top" />
          </td>
          <td class="td-status-badge" *ngIf="!isItOnly && !isLnDOnly && !isAdminOrPc">
            <p-tag [value]="getTaskLabel(record.orientationStatus)" [severity]="getTaskSeverity(record.orientationStatus)"
              [style]="{ cursor: 'default' }" pTooltip="Orientation tasks" tooltipPosition="top" />
          </td>

          <!-- Welcome Email — hidden for IT-only and L&D-only users -->
          <td class="td-status-badge" *ngIf="!isItOnly && !isLnDOnly">
            <ng-container *ngIf="isAdminOrPc">
              <ng-container *ngIf="isEmailSent(record, 'Welcome Email Send'); else welcomeBtn">
                <p-tag value="Sent" severity="success" pTooltip="Welcome email sent" tooltipPosition="top" />
              </ng-container>
              <ng-template #welcomeBtn>
                <p-button icon="pi pi-envelope" size="small"
                  [severity]="hasWorkEmail(record) ? 'warn' : 'secondary'" [text]="true"
                  [disabled]="!hasWorkEmail(record)"
                  (onClick)="sendEmail(record, 'Welcome Email Send', 'Welcome')"
                  [pTooltip]="hasWorkEmail(record) ? 'Send welcome email' : 'Add work email to enable sending'"
                  tooltipPosition="top" />
              </ng-template>
            </ng-container>
            <ng-container *ngIf="!isAdminOrPc">
              <p-tag *ngIf="isEmailSent(record, 'Welcome Email Send')" value="Sent" severity="success" />
              <span *ngIf="!isEmailSent(record, 'Welcome Email Send')" class="text-muted" style="font-size:0.8rem">—</span>
            </ng-container>
          </td>

          <!-- Actions — view always; edit/delete admin/pc only -->
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button icon="pi pi-eye" [text]="true" severity="info" size="small"
                pTooltip="View Details" tooltipPosition="top" (onClick)="viewEmployeeDetails(record)" />
              <p-button *ngIf="isAdminOrPc" icon="pi pi-pencil" [text]="true" severity="info" size="small"
                pTooltip="Edit Employee" tooltipPosition="top" (onClick)="editEmployee(record)" />
              <p-button *ngIf="isAdminOrPc" icon="pi pi-trash" [text]="true" severity="danger" size="small"
                pTooltip="Delete" tooltipPosition="top" (onClick)="deleteRecord(record)" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td [attr.colspan]="(isItOnly || isLnDOnly) ? 6 : 10" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No onboarding employees found</p>
              <p class="empty-description">Use the "Start Onboarding" button in Employee Management to begin the process</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Task Management Dialog -->
<p-dialog
  [visible]="displayTaskDialog"
  (visibleChange)="displayTaskDialog = $event"
  [header]="selectedRecord ? 'Onboarding Tasks — ' + selectedRecord.employeeName : 'Onboarding Tasks'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true"
  [style]="{ width: '700px' }">

  <div class="task-dialog-content" *ngIf="selectedRecord">
    <!-- Employee info bar -->
    <div class="task-employee-info">
      <div class="info-item"><span class="info-label">Name</span><span class="info-value">{{ selectedRecord.employeeName }}</span></div>
      <div class="info-item"><span class="info-label">Designation</span><span class="info-value">{{ selectedRecord.designationName || '-' }}</span></div>
      <div class="info-item"><span class="info-label">Department</span><span class="info-value">{{ selectedRecord.departmentName || '-' }}</span></div>
      <div class="info-item"><span class="info-label">Joining Date</span><span class="info-value">{{ formatDate(selectedRecord.joiningDate) }}</span></div>
      <div class="info-item">
        <span class="info-label"><i class="pi pi-envelope" style="font-size:0.65rem"></i> Work Email</span>
        <span class="info-value" [class.info-value--empty]="!dialogWorkEmail && !selectedRecord.employeeEmail">
          {{ dialogWorkEmail || selectedRecord.employeeEmail || '— not set' }}
        </span>
      </div>
      <div class="info-item">
        <span class="info-label"><i class="pi pi-microsoft" style="font-size:0.65rem"></i> Entra ID Group</span>
        <span class="info-value" [class.info-value--empty]="!selectedRecord.entraIdGroup">
          {{ entraIdGroupLabel(selectedRecord.entraIdGroup) || '— not set' }}
        </span>
      </div>
    </div>

    <!-- Category filter chips — IT/L&D users are locked to their category, no clear button -->
    <div class="task-category-filter" *ngIf="!dialogFilterCategory && isAdminOrPc">
      <small class="filter-hint">Showing all task categories</small>
    </div>
    <div class="task-category-filter" *ngIf="dialogFilterCategory">
      <p-tag [value]="getCategoryLabel(dialogFilterCategory)" severity="info" />
      <p-button *ngIf="isAdminOrPc && !restrictedCategory"
        icon="pi pi-times" [text]="true" size="small" severity="secondary"
        (onClick)="dialogFilterCategory = null" pTooltip="Show all categories" />
    </div>

    <!-- Task sections by category -->
    <div *ngFor="let cat of taskCategories" class="task-category-section">
      <!-- P&C group header before first P&C sub-category -->
      <div *ngIf="cat === 'PnC.Day1'" class="task-group-header">
        <i class="pi pi-users"></i>
        P&C — People & Culture
      </div>
      <h4 class="task-category-title" [class.task-subcategory-title]="cat.startsWith('PnC.')">
        <p-checkbox [binary]="true" [ngModel]="isCategoryAllDone(cat)" (ngModelChange)="toggleCategory(cat, $event)" />
        <i [class]="getCategoryIcon(cat)"></i>
        {{ getCategoryLabel(cat) }}
        <span class="select-all-hint">Select all</span>
      </h4>
      <ng-container *ngFor="let task of getTasksByCategory(cat)">
        <div class="task-item">
          <p-checkbox [(ngModel)]="task.isCompleted" [binary]="true" [inputId]="task.id" />
          <label [for]="task.id" class="task-label" [class.task-completed]="task.isCompleted">
            {{ task.taskName }}
          </label>
          <!-- Inline work email input for "Email Account Setup" in IT category -->
          <input *ngIf="task.taskName === 'Email Account Setup' && cat === 'IT'"
            pInputText type="email" [(ngModel)]="dialogWorkEmail"
            placeholder="Enter work email..."
            class="email-setup-input"
            (click)="$event.stopPropagation()" />
          <!-- Read-only echo of the group picked on the employee form, shown on any
               task whose name mentions the Entra ID group, so IT sees which group to
               add the joiner to. Matched loosely because this task is admin-created
               in Task Templates, so its exact wording varies. -->
          <span *ngIf="cat === 'IT' && isEntraGroupTask(task)"
            class="entra-group-value"
            [class.entra-group-value--empty]="!selectedRecord.entraIdGroup"
            [pTooltip]="selectedRecord.entraIdGroup ? 'Entra ID group selected on the employee record' : 'No Entra ID group set — edit the employee to select one'"
            tooltipPosition="top">
            <i class="pi pi-microsoft"></i>
            {{ entraIdGroupLabel(selectedRecord.entraIdGroup) || 'Not set' }}
          </span>
          <!-- Email send icon for email-related tasks (driven by emailType field) -->
          <p-button *ngIf="isEmailTask(task)" icon="pi pi-envelope" [text]="true" size="small"
            [severity]="task.isCompleted ? 'success' : (canSendEmailTask(task) ? 'warn' : 'secondary')"
            [pTooltip]="task.isCompleted ? (getEmailTypeLabel(task.emailType!) + ' already sent') : (canSendEmailTask(task) ? ('Send ' + getEmailTypeLabel(task.emailType!)) : 'Add work email first to enable sending')"
            tooltipPosition="top"
            [disabled]="task.isCompleted || !canSendEmailTask(task)"
            (onClick)="sendEmailForTask(task)" />
          <span *ngIf="task.isCompleted" class="task-done-badge">
            <i class="pi pi-check"></i> Done
          </span>
        </div>

        <!-- Welcome Pack sub-items under "Prepare Welcome Pack" task -->
        <div *ngIf="task.taskName.includes('Welcome Pack') && dialogWelcomePackItems.length > 0" class="welcome-pack-subitems">
          <div *ngFor="let item of dialogWelcomePackItems" class="task-item task-subitem">
            <p-checkbox [(ngModel)]="item.isProvided" [binary]="true" [inputId]="'wp-' + item.id" />
            <label [for]="'wp-' + item.id" class="task-label" [class.task-completed]="item.isProvided">
              {{ item.itemName }}
            </label>
            <div *ngIf="item.itemName.toLowerCase().includes('shirt')" class="tshirt-selectors">
              <p-select [(ngModel)]="item.tShirtType" [options]="tShirtTypes" optionLabel="label" optionValue="value"
                placeholder="Type" [style]="{ width: '100px' }" appendTo="body" />
              <p-select [(ngModel)]="item.tShirtSize" [options]="tShirtSizes" optionLabel="label" optionValue="value"
                placeholder="Size" [style]="{ width: '80px' }" appendTo="body" />
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="getTasksByCategory(cat).length === 0" class="task-empty">No tasks in this category</div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Sync tasks from templates" icon="pi pi-sync" (onClick)="syncTasks()"
                severity="secondary" [outlined]="true" [loading]="syncingTasks"
                pTooltip="Add any template tasks missing from this record" tooltipPosition="top" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="closeTaskDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveTasks()" severity="primary" [loading]="savingTasks" />
    </div>
  </ng-template>
</p-dialog>

<!-- Employee Details View Dialog -->
<p-dialog
  [visible]="displayViewDialog"
  (visibleChange)="displayViewDialog = $event"
  [header]="viewingEmployee ? viewingEmployee.name + ' — Details' : 'Employee Details'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true"
  [style]="{ width: '680px' }">

  <div *ngIf="loadingEmployeeDetails" class="loading-container">
    <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
    <span>Loading...</span>
  </div>

  <div *ngIf="!loadingEmployeeDetails && viewingEmployee" class="employee-details-view">
    <!-- Header info bar -->
    <div class="details-header-bar">
      <div class="details-name-block">
        <span class="details-name">{{ viewingEmployee.name }}</span>
        <span class="details-sub">{{ viewingEmployee.designationName || '—' }}</span>
      </div>
      <p-tag [value]="viewingEmployee.isActive ? 'Active' : 'Inactive'"
        [severity]="viewingEmployee.isActive ? 'success' : 'secondary'" />
    </div>

    <!-- Details grid -->
    <div class="details-grid">
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-envelope"></i> Work Email</span>
        <span class="detail-value">{{ viewingEmployee.email || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-envelope"></i> Personal Email</span>
        <span class="detail-value">{{ viewingEmployee.personalEmail || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-phone"></i> Mobile</span>
        <span class="detail-value">{{ viewingEmployee.mobileNumber || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-id-card"></i> ID Number</span>
        <span class="detail-value">{{ viewingEmployee.idNumber || '—' }}</span>
      </div>
      <div class="detail-item detail-item--full">
        <span class="detail-label"><i class="pi pi-shield"></i> Roles</span>
        <span class="detail-value">{{ (viewingEmployee.roleTitles && viewingEmployee.roleTitles.length ? viewingEmployee.roleTitles.join(', ') : viewingEmployee.roleTitle) || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-users"></i> Service Group</span>
        <span class="detail-value">{{ (viewingEmployee.serviceGroupNames && viewingEmployee.serviceGroupNames.length ? viewingEmployee.serviceGroupNames.join(', ') : viewingEmployee.serviceGroupName) || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-tag"></i> Designation</span>
        <span class="detail-value">{{ viewingEmployee.designationName || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-th-large"></i> Category</span>
        <span class="detail-value">{{ viewingEmployee.categoryName || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-briefcase"></i> Employment Type</span>
        <span class="detail-value">{{ viewingEmployee.employmentType || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-user"></i> Head of Department</span>
        <span class="detail-value">{{ viewingEmployee.headOfDepartmentName || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-calendar"></i> Joining Date</span>
        <span class="detail-value">{{ formatDate(viewingEmployee.joiningDate) }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-microsoft"></i> Entra ID Group</span>
        <span class="detail-value">{{ entraIdGroupLabel(viewingEmployee.entraIdGroup) || '—' }}</span>
      </div>
      <div class="detail-item detail-item--full">
        <span class="detail-label"><i class="pi pi-home"></i> Residential Address</span>
        <span class="detail-value">{{ viewingEmployee.residentialAddress || '—' }}</span>
      </div>
      <div class="detail-item detail-item--full">
        <span class="detail-label"><i class="pi pi-map-marker"></i> Current Address</span>
        <span class="detail-value">{{ viewingEmployee.currentAddress || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-phone"></i> Emergency Contact</span>
        <span class="detail-value">{{ viewingEmployee.emergencyContactName || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-phone"></i> Emergency Number</span>
        <span class="detail-value">{{ viewingEmployee.emergencyContactNumber || '—' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-linkedin"></i> LinkedIn</span>
        <a *ngIf="viewingEmployee.linkedInUrl" [href]="viewingEmployee.linkedInUrl" target="_blank"
          class="detail-link">View Profile</a>
        <span *ngIf="!viewingEmployee.linkedInUrl" class="detail-value">—</span>
      </div>
      <div class="detail-item">
        <span class="detail-label"><i class="pi pi-file"></i> CV / Resume</span>
        <a *ngIf="viewingEmployee.cvAttachmentUrl" [href]="viewingEmployee.cvAttachmentUrl" target="_blank"
          class="detail-link">Open CV</a>
        <span *ngIf="!viewingEmployee.cvAttachmentUrl" class="detail-value">—</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Close" icon="pi pi-times" (onClick)="closeViewDialog()" severity="secondary" [outlined]="true" />
      <p-button *ngIf="viewingEmployee && isAdminOrPc" label="Edit Employee" icon="pi pi-pencil" severity="info"
        (onClick)="editEmployeeFromView()" />
    </div>
  </ng-template>
</p-dialog>

<!-- Shared Employee Form Dialog (Add & Edit — no code duplication) -->
<app-employee-form-dialog
  [(visible)]="displayEmployeeFormDialog"
  [employee]="employeeToEdit"
  [startOnboardingByDefault]="true"
  [hasOnboardingRecord]="!!employeeToEdit"
  (saved)="onEmployeeSaved($event)"
  (cancel)="onEmployeeFormCancel()" />
